import * as Yup from 'yup';

export function getAuthInitialValues(initialVal) {
    return {
        purchasingLimit: initialVal,
    }
}
const VALIDATION_SCHEMA = Yup.object().shape({
    purchasingLimit: Yup.string().trim().required('Purchasing Limit is required.'),
});

export { VALIDATION_SCHEMA };
